import { AuthProvider } from 'react-admin';
import { AuthService } from './services/AuthService';

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    try {
      const success = await AuthService.login({ email: username, password });
      if (success) {
        return Promise.resolve();
      } else {
        throw new Error('Login failed');
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },

  logout: async () => {
    await AuthService.logout();
    return Promise.resolve();
  },

  checkError: ({ status }: { status: number }) => {
    if (status === 401 || status === 403) {
      // Clear tokens using AuthService to ensure proper cleanup
      AuthService.logout();
      return Promise.reject();
    }
    return Promise.resolve();
  },

  checkAuth: () => {
    // Use AuthService to check authentication status
    return AuthService.isAuthenticated() ? Promise.resolve() : Promise.reject();
  },

  getPermissions: () => {
    const user = AuthService.getCurrentUser();
    if (user) {
      return Promise.resolve(user.role || 'admin');
    }
    return Promise.reject();
  },

  getIdentity: async () => {
    let user = AuthService.getCurrentUser();
    // Existing sessions may only have the basic fallback (no name) — enrich once.
    if (user && !user.name) {
      const enriched = await AuthService.fetchAndStoreProfile();
      if (enriched) user = enriched;
    }
    if (user) {
      const fullName =
        [user.name, user.lastname].filter(Boolean).join(' ') || user.email || 'Admin';
      return {
        id: user.id ?? user.email,
        fullName,
        email: user.email,
        avatar: user.profile_picture_url,
      };
    }
    return Promise.reject();
  },
};

export default authProvider;